import useMenu from './useMenu';
import { useMemo } from 'react';
import { CategoryType } from '../../services/exports/Constants';

const useMostPopularCategory = () => {
  const { categories } = useMenu();

  return useMemo(() => categories.find((category) => category.type === CategoryType.MostPopular), [categories]);
};

export default useMostPopularCategory;
